/**
 * joi.js のバリデートメッセージの翻訳Object
 */

export const localizeMessage = {
  unknown: 'エラーです。',
  invalid: '不正な値です。',
  allowOnly: '選択項目に問題があります。',
  default: 'エラーです。',
  empty: '必須です。',
  required: '必須です。',
  allowUnknown: '',
  string_base: '文字で入力してください。',
  string_min: `文字以上で入力してください。`,
  string_max: `文字以下で入力してください。`,
  string_length: `文字で入力してください。`,
  number: '必須です。',
  email: 'メールアドレスが正しくありません。',
};
export const localize = {
  root: 'value',

  key: '"{{!label}}" ',

  messages: {
    wrapArrays: true,
  },

  any: {
    unknown: '[unknown]エラーです。',
    invalid: '[invalid]エラーな値です。',
    empty: '[empty]は空にしてはいけません。',
    required: '[required]必須です。',
    allowOnly: '[allowOnly]{{valids}}のいずれかにしてください。',
    default: '[error]エラーが発生しました。',
    allowUnknown: '[allowUnknown]',
  },

  object: {
    child: '{{reason}}',
  },

  number: {
    base: '[number] must be a number',
  },

  boolean: {
    base: '[empty]は空にしてはいけません。',
  },

  string: {
    base: '[string_base]文字列でなければなりません。',
    min: '[string_min]{{limit}}',
    max: '[string_max]{{limit}}',
    length: '[string_length]{{limit}}',
    // alphanum: '[string_alphanum]英数字だけにしてください。',
    // regex: {
    //   base: 'regex-base,"{{!value}}"は{{pattern}}に一致しません。',
    //   name: 'regex-name,"{{!value}}"が{{name}}のパターンに一致しません。',
    //   invert: {
    //     base: 'regex-invert-base,"{{!value}}"は{{pattern}}の反転パターンに一致します。',
    //     name: 'regex-invert-name,"{{!value}}"は{{name}}の反転パターンに一致します。'
    //   }
    // },
    email: '[email]メールアドレスを入力してください。',
  },
};

export default localize;



// WEBPACK FOOTER //
// ./src/utilities/validateMessage.js